import { useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import marketing from "../../assets/icons/marketing.svg";
import logoType from "../../assets/images/Logotype.svg";
import logout from "../../assets/images/logout.svg";
import { useGetUserInformation, usersKeys } from "../../features/users";
import { api } from "../../utils/axios/Config";
import { handleErrorApi } from "../../utils/utils";
import AlertButton from "../ui/AlertButton";

const Header = ({ handleopenNtification: _handleopenNtification, unreadNotice: _unreadNotice }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: user } = useGetUserInformation();
  const isMarketer = user?.is_marketer;

  const handleLogOut = async () => {
    try {
      const res = await api.post("/users/logout/");
      if (res.status === 204) {
        //console.log("ogout succesfully")
        void queryClient.removeQueries({ queryKey: usersKeys.all });
        Cookies.remove("token");
        navigate("/auth");
      }
    } catch (error) {
      if ((error.status === 401) | (error.status === 404)) {
        void queryClient.removeQueries({ queryKey: usersKeys.all });
        Cookies.remove("token");
        navigate("/auth");
      }
      handleErrorApi(error);
    }
  };

  return (
    // <div className="w-full z-[999] fixed md:sticky top-0 flex md:max-h-[45px] min-h-[40px] h-[7%] md:h-[7%] justify-between items-center p-[8px] bg-primary-40 md:bg-primary-20 md:rounded-v-2xl md:mb-2 ">
    <div className="w-full  flex justify-between   p-2 z-[999] bg-primary-40 md:bg-primary-20 md:rounded-v-2xl md:mb-2 ">
      {/* logo & name  */}
      <div className="flex items-center justify-center gap-1">
        <img src="/images/vandalogo.png" alt="vanda-logo" className="w-[32px]  " />
        <img src={logoType} alt="logoType" className="w-[69px]  md:w-[109px] md:h-[20px]" />
      </div>

      <div className="flex gap-1 md:gap-2 items-center ">
        {isMarketer && (
          <button
            className=" flex items-center gap-1 hover:scale-105 px-3 py-[5px] rounded-xl   border-dark border-[0.75px] md:hidden  text-[11px] font-semibold "
            onClick={() => navigate("/marketing/users")}
          >
            <img src={marketing} alt="" width={16} height={16} />
            <p>بازاریابی</p>
          </button>
        )}
        <AlertButton onClick={() => handleLogOut()}>
          <div className="btn-exit flex items-center gap-1 hover:scale-105">
            <img src={logout} alt="" width={16} height={16} />
            <p>خروج از حساب کاربری</p>
          </div>
        </AlertButton>
      </div>
    </div>
  );
};

export default Header;
